import { type MarkedRegion, type PageRegion, PdfPagesViewer } from '~/components/pdf-pages-viewer';

/**
 * The rendered pages, shown when the toolbar preview toggle is active. With comments on, a
 * drag on a page draws a box for a new comment and existing comment boxes are drawn back.
 */
export function EditorPreviewPane(props: {
  previewUrl: string;
  onLoad: () => void;
  regions?: MarkedRegion[];
  onDrawRegion?: (region: PageRegion) => void;
  onRegionClick?: (id: string) => void;
}) {
  return (
    <div className="relative flex flex-col h-full overflow-hidden bg-neutral-50 dark:bg-neutral-900">
      <PdfPagesViewer
        src={props.previewUrl}
        title="Document Preview"
        onLoad={props.onLoad}
        className="h-full rounded-none border-0"
        regions={props.regions}
        onDrawRegion={props.onDrawRegion}
        onRegionClick={props.onRegionClick}
      />
    </div>
  );
}
